import config from "@/api/config";

export default (map) => {
  config({
    custom_map: map,
  });
};
